<template>
    <v-dialog v-model="getModalListarVenda" scrollable fullscreen persistent :overlay="false" max-width="500px"
        transition="dialog-transition">
        <ListarVendaCard botaoVisualizarVendaTroca="false" />
    </v-dialog>
</template>

<script>
    import ListarVendaCard from '@/pages/venda/ListarVendaCard'
    import { mapGetters, mapActions } from 'vuex'
    export default {
        components: { ListarVendaCard },
        computed: {
            ...mapGetters([
                'getModalListarVenda'
            ])
        }

    }
</script>